<template>
	<div class="knd-intro" :style="myStyle" :class="[customClass]" ref="intro">
		<div class="knd-paragraaf knd-intro-container " ref="container">
			<h2 class="knd-h2" v-if="data.titel">{{ data.titel }}</h2>
			<div class="knd-paragraaf-max" v-html="data.tekst"></div>

			<div class="knd-paragraaf-max knd-intro-disclaimer" v-html="data.disclaimer"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'App',
    props: ['data'],
	data() {
		return {
			myStyle:{
        backgroundColor: '#' + this.data.color || '#00DEB2'
      },
			customClass: this.data.className || '',
		}
	},
	mounted: function() {
		// this.resizeContent();
		// this.$refs.container.style.position = 'fixed';
		// window.addEventListener("resize", this.debounce( this.resizeContent, 150 ));

	},
	methods: {
		resizeContent() {
			// Do loads of stuff once window has resized
			console.log('resized');
			let el = this.$refs.intro;
			let height = el.offsetHeight;
			el.style.height = height + 'px';
		},

		debounce(func, time = 100){
			var timer;
			return function(event){
					if(timer) clearTimeout(timer);
					timer = setTimeout(func, time, event);
			};
	}


	}
}
</script>


<style lang="scss">

.knd-intro {
  text-align: center;
  background: var(--intro-background);
  color: var(--intro-color);
	font-weight: bold;
	padding-bottom: 2em;
	padding-top: 2em;
	
	// @include sm { 
	// 	position: sticky;
	// 	top: 0;
	// }

	.knd-intro-disclaimer {
		font-size: .8em;
		font-weight: normal;
	}
}

.knd-intro-container {
	width: 100%;
}

.knd-lead {
	color: #2A3700;
	text-decoration: underline;
	font-size: 1.1em;
	max-width: 740px;
	margin: 0 auto;

	.knd-paragraaf {
		padding-bottom: 0;
	}
}

</style>